<template>
  <div class="meta-preview">
    <a :href="url" target="_blank">
      <div v-if="image" class="image-preview" :style="{backgroundImage: `url(${image})`}"></div>
      <div class="content-preview">
        <div class="title">{{ title.substring(0, 100) }}</div>
        <div class="url">{{ hostUrl }}</div>
      </div>
    </a>
    <div class="remove" v-if="canDelete">
      <button @click="removeMeta">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      default: '',
    },
    title: {
      default: '',
    },
    description: {
      default: '',
    },
    url: {
      default: '',
    },
    canDelete: {
      default: true,
    },
  },

  computed: {
    hostUrl () {
      const splitUrl = this.url.split('/');
      const hostArray = [splitUrl[0], splitUrl[2]];

      return hostArray.join('//');
    },
  },

  methods: {
    removeMeta () {
      this.$emit('onRemoveMeta');
    },
  },
};
</script>

<style scoped lang="scss">
.meta-preview {
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  margin-bottom: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15);

  a {
    color: #000 !important;
  }

  .image-preview {
    width: 100%;
    height: 180px;
    margin-right: 8px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .content-preview {
    padding: 8px;

    .title {
      font-weight: 600;
    }

    .url {
      font-size: 12px;
    }
  }

  .remove {
    align-self: center;
    margin-left: auto;

    button {
      border: none;
      background: transparent;
    }
  }
}
</style>
